export var ActivityManagementStatus;
(function (ActivityManagementStatus) {
    ActivityManagementStatus["ACTIVE"] = "active";
    ActivityManagementStatus["DEACTIVATE"] = "inactive";
    ActivityManagementStatus["EXPIRED"] = "expired";
})(ActivityManagementStatus || (ActivityManagementStatus = {}));
//# sourceMappingURL=ActivityManagementStatus.js.map